import { ActionReducerMap } from '@ngrx/store';
import * as fromAircraftEvent from './aircraft-event/aircraft-event.reducer';
import * as fromAircraftProfile from './aircraft-profile/aircraft-profile.reducer';
import * as fromPersonProfile from './person-profile/person-profile.reducer';
import * as fromTrainingRequirement from './training-requirement/training-requirement.reducer';
import * as fromStaffEvent from './staff-event/staff-event.reducer';
import * as fromCompanyProfile from './company-profile/company-profile.reducer';
import * as fromTrip from './trip/trip.reducer';
import * as fromTripManager from './trip-manager/trip-manager.reducer';
import * as fromShared from './shared-audit.reducer';
import * as fromPostedFlight from './posted-flight/posted-flight.reducer';
import * as fromSimulatedFlight from './simulated-flight/simulated-flight.reducer';
import * as fromExpense from './expense/expense.reducer';

export const SHARED_AUDIT_FEATURE = 'sharedAudit';

export interface State {
  shared: fromShared.State;
  aircraftEvent: fromAircraftEvent.State;
  aircraftProfile: fromAircraftProfile.State;
  personProfile: fromPersonProfile.State;
  trainingRequirement: fromTrainingRequirement.State;
  staffEvent: fromStaffEvent.State;
  companyProfile: fromCompanyProfile.State;
  trip: fromTrip.State;
  tripManager: fromTripManager.State;
  postedFlight: fromPostedFlight.State;
  simulatedFlight: fromSimulatedFlight.State;
  expense: fromExpense.State;
}

export const reducers: ActionReducerMap<State> = {
  shared: fromShared.reducer,
  aircraftEvent: fromAircraftEvent.reducer,
  aircraftProfile: fromAircraftProfile.reducer,
  personProfile: fromPersonProfile.reducer,
  trainingRequirement: fromTrainingRequirement.reducer,
  staffEvent: fromStaffEvent.reducer,
  companyProfile: fromCompanyProfile.reducer,
  trip: fromTrip.reducer,
  tripManager: fromTripManager.reducer,
  postedFlight: fromPostedFlight.reducer,
  simulatedFlight: fromSimulatedFlight.reducer,
  expense: fromExpense.reducer
};
